import React, { useEffect, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment";
import { makeStyles, useTheme } from "@material-ui/styles";
import {
  TextField,
  Grid,
  Card,
  IconButton,
  CardContent,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  CircularProgress,
  TableRow,
  Typography,
  TableContainer,
  Chip,
  Button,
  Avatar,
} from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Tooltip from "@material-ui/core/Tooltip";

import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import jMoment from "moment-jalaali";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import { getInitials } from "helpers";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { RTL } from "components";
import Pagination from "@material-ui/lab/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { axios } from "./../../../../axios";
import { Loading, showSnackbar } from "redux/Action";
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import JalaliUtils from "@date-io/jalaali";
import { values } from "underscore";
const useStyles = makeStyles((theme) => ({
  root: {},

  tableCol: {
    padding: 12,
    fontSize: 13,
  },
  tableCol2: {
    padding: 2,
    fontSize: 10,
  },
  iconBtn: {
    padding: 5,
  },
  content: {
    padding: 0,
    margin: 10,
  },
  inner: {
    minWidth: 1050,
  },
  nameContainer: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  actions: {
    justifyContent: "flex-end",
  },
  name: {
    marginRight: theme.spacing(1),
  },
  tableContainer: {
    height: "80vh",
  },
  input: {
    marginTop: theme.spacing(1),
    textAlign: "center",
    width: "100%",
    marginBottom: theme.spacing(1),

    backgroundColor: "white",
  },

  gridToolbar: {
    marginRight: 10,
  },
  inputGroup: {
    marginTop: theme.spacing(2),
  },
  button: {
    textAlign: "center",
    width: "100%",

    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),

    color: "#273C75",
    // paddingLeft:25,
    // marginRight: theme.spacing(1),
    padding: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#273C75",
      color: "white",
    },
  },
  buttonDel: {
    textAlign: "center",
    width: "100%",

    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderColor: "#E65D62",
    color: "#E65D62",
    // paddingLeft:25,
    // marginRight: theme.spacing(1),
    padding: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#E65D62",
      borderColor: "white",

      color: "white",
    },
  },
}));

let filter_txt = "";

let initialGet = true;
const ListRequestTable = (props) => {
  const {
    className,
    showEdit,
    ChangeId,
    showInfo,
    onDelete,
    selData,
    reload,
    edit,
    del,
    reloadFunc,
    ...rest
  } = props;

  const classes = useStyles(props);

  const convertNumbers2English = function(string) {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660;
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0;
      });
  };

  const token = useSelector((state) => state.token);
  const [data, setData] = React.useState([]);
  const [dataUser, setDataUser] = React.useState([]);

  const [LastPage, setLastPage] = React.useState(1);
  const [Page, setPage] = React.useState(1);
  const [selectedDate, handleDateChange] = useState(null);
  const [countData, setCountData] = useState('0');

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const handleChangePage = (event, value) => {
    setPage(value);
  };
  const [delFilter, setDelFilter] = useState(false);
  const [initLoad, SetInitLoad] = useState(true);

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [Allcities, setAllcities] = useState([]);
  const [AllTruck_types, setTruck_types] = useState([]);
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [shipmentSel, setShipmentSel] = useState("");
  const [citySel, setCitySel] = useState("");
  const [cityOriginSel, SetcityOriginSel] = useState("");

  const [shipmentNameSel, setShipmentNameSel] = useState("");
  const [cityNameSel, setCityNameSel] = useState("");
  const [cityOriginNameSel, setcityOriginNameSel] = useState("");

  const Get_Component = async () => {
    try {
      const res = await axios.get("shipments/create", {
        headers: headers,
      });
      let dataCity = res.data.cities;

      let final_City = [];
      dataCity.forEach((obj, i) => {
        final_City = [
          ...final_City,
          {
            id: obj.id,
            province_id: obj.province_id,
            county_id: obj.county_id,
            name: obj.get_province?.name + " " + obj.name,
          },
        ];
      });
      setAllcities(final_City);
      setTruck_types(res.data.truck_types);

  


      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      console.log(e.response, "eeeeeeeee");
    }
  };

  const GetUser = async () => {
    try {
     
     
          const resUserData = await axios.get(`auth/getCurrentUser`, {
            headers:headers
          });
         console.log(resUserData.data,"ressss")
          setDataUser(resUserData.data);
    // Super-Admin
      


      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      console.log(e.response, "eeeeeeeee");
    }
  };

  useEffect(() => {
      GetUser();
     dispatch(Loading());
  }, []);

  const GetData = async () => {
    try {
      const resUserData = await axios.get(`auth/getCurrentUser`, {
        headers:headers
      });
      const res = await axios.get(
        `requests?${(resUserData.data.roles.findIndex(e => e.name === 'Super-Admin')===0)?``:`origin_province_id=`+resUserData.data.staff?.company?.city?.get_province?.id}${citySel != "" ? `&dest_city_id=` + citySel : ""}${
          cityOriginSel != "" ? `&origin_city_id=` + cityOriginSel : ""
        }
        
          // selectedDate != null
          //   ? created_at= +
          //     convertNumbers2English(selectedDate.format("YYYY-MM-DD"))
          //   : ""
        
        ${`&page=` + Page}`,
        {
          headers: headers,
        }
      );
      //  console.log(res.data.shipments.data)

      if (cityOriginSel != "" || citySel != "") {
        setDelFilter(true);
      }
      dispatch(Loading());
      setCountData(res.data.shipments.total)
      if (initLoad && resUserData.data.roles.findIndex(e => e.name === 'Super-Admin')===0) {
        SetInitLoad(false);
        Get_Component();
        dispatch(Loading());
      }
      setLastPage(res.data.shipments.last_page);
      if (LastPage == 1) {
        setPage(1);
      }
      setData(res.data.shipments.data);
    } catch (e) {
      dispatch(Loading());
      // alert("sss"+JSON.stringify(e))

    }
    //alert(res)
  };

  useEffect(() => {
    dispatch(Loading());
    GetData();
  }, [Page, reload]);

  const DeletefilterBtn = () => {
    // handleDateChange(null);
    setCitySel("");
    // setShipmentSel("");
    // setShipmentNameSel("");
    setCityNameSel("");

    SetcityOriginSel("");
    setcityOriginNameSel("");

    setDelFilter(false);

    reloadFunc();
    setPage(1);
    // setData([]);
    // GetData();
    // dispatch(Loading());
  };

  const handleKeyDown = (event) => {
    setPage(1);
    if (event.key === "Enter") {
      filter_txt = event.target.value;
      setData([]);
      GetData();
      dispatch(Loading());
    }
  };

  const filterBtn = () => {
    if (cityOriginSel == "" && citySel == "") {
      dispatch(
        showSnackbar(true, "error", "جهت اعمال فیلتر یکی از موارد را وارد کنید")
      );
    } else {
      setPage(1);
      dispatch(Loading());
      GetData();
    }
  };

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
          {!isLoading ? (
            <>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <RTL>
                { dataUser?.roles?.findIndex(e => e.name === 'Super-Admin')===0?

                  <Grid container>
                    {/* <Grid
                      className={classes.gridToolbar}
                      alignItems="flex-start"
                      item
                      xs={3}
                      sm={3}
                    >
                      <DatePicker
                        className={classes.input}
                        inputVariant="outlined"
                        okLabel="تأیید"
                        ampm={false}
                        cancelLabel="لغو"
                        label="تاریخ بار"
                        labelFunc={(date) =>
                          date ? date.format("jYYYY/jMM/jDD") : ""
                        }
                        value={selectedDate ? moment(selectedDate) : null}
                        onChange={(v) => {
                          handleDateChange(v);
                          // setError({ ...error, start_date: "" })
                        }}
                      />
                    </Grid> */}

                    {/* <Grid
                      className={classes.gridToolbar}
                      alignItems="flex-start"
                      item
                      xs={3}
                      sm={3}
                    >
                      <Autocomplete
                        noOptionsText="همچنین ماشینی وجود ندارد"
                        options={AllTruck_types}
                        getOptionLabel={(option) => option.full_name}
                        id="truck_type_id"
                        value={{
                          full_name: `${shipmentNameSel}`,
                        }}
                        onChange={(event, value) => {
                          if (value != null) {
                            setShipmentSel(value.id);
                            setShipmentNameSel(value.full_name);
                          } else {
                            setShipmentSel("");
                            setShipmentNameSel("");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            className={classes.input}
                            {...params}
                            label="نوع ماشین "
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid> */}


                    <Grid
                      className={classes.gridToolbar}
                      alignItems="flex-start"
                      item
                    
                      xs={12}
                      // md={4}
                      sm={4}
                    >
                      <Autocomplete
                        noOptionsText="همچنین شهری وجود ندارد"
                        options={Allcities}
                        groupBy={(option) => option.get_province?.name}
                        getOptionLabel={(option) => option.name}
                        id="origin_city_id"
                        value={{
                          name: `${cityOriginNameSel}`,
                        }}
                        onChange={(event, value) => {
                          if (value != null) {
                            SetcityOriginSel(value.id);
                            setcityOriginNameSel(value.name);
                          } else {
                            SetcityOriginSel("");
                            setcityOriginNameSel("");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            className={classes.input}
                            {...params}
                            label="مبدا "
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>

                    <Grid
                      className={classes.gridToolbar}
                      alignItems="flex-start"
                      item
                      xs={12}
                      // md={4}
                      sm={4}
                    >
                      <Autocomplete
                        noOptionsText="همچنین شهری وجود ندارد"
                        options={Allcities}
                        groupBy={(option) => option.get_province?.name}
                        getOptionLabel={(option) => option.name}
                        id="dest_city_id"
                        value={{
                          name: `${cityNameSel}`,
                        }}
                        onChange={(event, value) => {
                          if (value != null) {
                            setCitySel(value.id);
                            setCityNameSel(value.name);
                          } else {
                            setCitySel("");
                            setCityNameSel("");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            className={classes.input}
                            {...params}
                            label="مقصد "
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                    <Grid
                      className={classes.gridToolbar}
                      alignItems="flex-start"
                      item
                      xs={12}
                      sm={delFilter?2:3}
                      // sm={delFilter?2:3}
                    >
                      <Button
                        variant="outlined"
                        size="medium"
                        onClick={() => filterBtn()}
                        color="secondary"
                        className={classes.button}
                      >
                        <SearchIcon />
                      </Button>
                    </Grid>

                    <Grid
                      className={classes.gridToolbar}
                      alignItems="flex-start"
                      item
                      xs={12}
                      // md={delFilter?1:2}

                      sm={delFilter?1:2}
                    >
                      {delFilter ? (
                        <Button
                          variant="outlined"
                          size="medium"
                          onClick={() => DeletefilterBtn()}
                          color="secondary"
                          className={classes.buttonDel}
                        >
                          <ClearIcon />
                        </Button>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Grid>
                :<Grid style={{display:'none'}}></Grid>}
                </RTL>
              </MuiPickersUtilsProvider>

              <div>
                {data ? (
                  data.length > 0 ? (
                    <>
                    <Chip
                        style={{
                          backgroundColor: '#6A3053',
                          width: 200,
                          color: 'white',
                          borderBottomLeftRadius: 0,
                          borderBottomRightRadius: 0,
                          fontSize: 13,
                        }}
                        label={`${countData} درخواست یافت شد`}
                      />
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">تاریخ ایجاد</TableCell>
                            <TableCell align="center">مبدا</TableCell>
                            <TableCell align="center">مقصد</TableCell>
                            <TableCell align="center">نوع بار</TableCell>
                            <TableCell align="center">نوع ماشین</TableCell>
                            <TableCell align="center">تناژ</TableCell>
                            <TableCell align="center">توضیحات</TableCell>
                            <TableCell align="center">تماس</TableCell>
                            {/* <TableCell align="center">عملیات</TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {data.map((dataBar) => (
                            <TableRow
                              className={classes.tableRow}
                              hover
                              key={dataBar.id}
                            >
                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {/* {data.created_at} */}
                                {jMoment(dataBar.created_at)
                                  .local("fa")
                                  .format("jYYYY/jM/jD")}
                              </TableCell>

                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar.origin?.get_province?.name +
                                  " " +
                                  dataBar.origin?.name}
                              </TableCell>

                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar.destination?.get_province?.name +
                                  " " +
                                  dataBar.destination?.name}
                              </TableCell>
                              {dataBar.shipment_type ? (
                                <TableCell
                                  className={classes.tableCol}
                                  align="center"
                                >
                                  <Chip
                                    style={{
                                      backgroundColor: "#00b894",
                                      color: "white",
                                    }}
                                    label={dataBar.shipment_type}
                                  />
                                </TableCell>
                              ) : (
                                <TableCell
                                  className={classes.tableCol}
                                  align="center"
                                >
                                  -
                                </TableCell>
                              )}

                              {dataBar.truck_model ? (
                                <TableCell
                                  className={classes.tableCol}
                                  align="center"
                                >
                                  {dataBar.truck_model?.truck_type?.name +
                                    " " +
                                    dataBar.truck_model?.name}
                                </TableCell>
                              ) : (
                                <TableCell
                                  className={classes.tableCol}
                                  align="center"
                                >
                                  -
                                </TableCell>
                              )}
                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar.tonnage == 0 ? "-" : dataBar.tonnage}
                              </TableCell>

                              <TableCell
                                className={classes.tableCol}
                                align="center"
                              >
                                {dataBar.desc == null ? "-" : dataBar.desc}
                              </TableCell>

                              <TableCell
                                className={classes.tableCol2}
                                align="center"
                              >
                                {dataBar.driver?.user?.cell ? (
                                  <Tooltip
                                    title={
                                      <div>
                                        {dataBar.driver?.user?.full_name
                                          ? dataBar.driver?.user?.full_name
                                          : "-"}
                                        <br />
                                        {dataBar.driver?.user?.cell
                                          ? dataBar.driver?.user?.cell
                                          : "-"}
                                      </div>
                                    }
                                    placement="right"
                                    arrow
                                  >
                                    <Button
                                      onClick={() => {
                                        showEdit();
                                        ChangeId(
                                          dataBar.id,
                                          jMoment(dataBar.created_at)
                                            .local("fa")
                                            .format("jYYYY/jM/jD"),
                                          dataBar.origin?.get_province?.name +
                                            " - " +
                                            dataBar.origin?.name,
                                          dataBar.destination?.get_province
                                            ?.name +
                                            " - " +
                                            dataBar.destination?.name,
                                            dataBar.shipment_type ?dataBar.shipment_type:'-',
                                            dataBar.truck_model ?dataBar.truck_model?.truck_type?.name +
                                            " - " +
                                            dataBar.truck_model?.name:"",
                                            dataBar.tonnage == 0 ? "-" : dataBar.tonnage,
                                            dataBar.desc == null ? "-" : dataBar.desc,
                                            dataBar.driver?.user?.full_name
                                          ? dataBar.driver?.user?.full_name
                                          : "-",
                                          dataBar.driver?.user?.cell
                                          ? dataBar.driver?.user?.cell
                                          : "-"
                                        );
                                      }}
                                    >
                                      <Avatar
                                        alt="شماره تماس"
                                        style={{
                                          width: 30,
                                          height: 30,
                                          borderRadius: 0,
                                        }}
                                        src="/images/phone.svg"
                                      />
                                    </Button>
                                  </Tooltip>
                                ) : (
                                  //                                   <ExpansionPanel
                                  //                                     className={classes.tableCol2}
                                  //                                     expanded={expanded === dataBar.id}
                                  //                                     onChange={handleChange(dataBar.id)}
                                  //                                   >
                                  //                                     <ExpansionPanelSummary>
                                  //                                       <Typography variant="caption" >                                      شماره تماس
                                  // </Typography>
                                  //                                     </ExpansionPanelSummary>

                                  //                                     <ExpansionPanelDetails>
                                  //                                       {dataBar.driver?.user?.cell}
                                  //                                     </ExpansionPanelDetails>
                                  //                                   </ExpansionPanel>
                                  "-"
                                )}
                              </TableCell>

                              {/* <TableCell align="center">
                              

                                <IconButton
                                  component="span"
                                  disabled={edit || del}
                                  style={
                                    edit || del
                                      ? { color: "#7f8c8d" }
                                      : { color: "#6c5ce7" }
                                  }
                                  onClick={() => {
                                    showEdit();
                                    ChangeId(dataBar.id);
                                  }}
                                >
                                  <EditIcon />
                                </IconButton>
                                <IconButton
                                  disabled={edit || del}
                                  style={
                                    edit || del
                                      ? { color: "#7f8c8d" }
                                      : { color: "#E65D62" }
                                  }
                                  onClick={() => {
                                    onDelete();
                                    ChangeId(dataBar.id);
                                    selData(
                                      data
                                        .filter((dt) => dt.id == dataBar.id)
                                        .map((filterData) => filterData)
                                    );
                                  }}
                                  component="span"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell> */}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      {LastPage > 1 ? (
                        <Pagination
                          style={{ margin: 10 }}
                          variant="outlined"
                          onChange={handleChangePage}
                          page={Page}
                          count={LastPage}
                          color="primary"
                        />
                      ) : (
                        ""
                      )}
                    </TableContainer>
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        alignItems: "center",
                        padding: 50,

                        height: "100%",
                        justifyContent: "center",
                      }}
                    >
                      <Typography>متاسفانه هیچ رکوردی یافت نشد</Typography>
                    </div>
                  )
                ) : (
                  ""
                )}
              </div>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flex: 1,
                alignItems: "center",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={24} />
            </div>
          )}
      </CardContent>
    </Card>
  );
};

ListRequestTable.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array.isRequired,
};

export default ListRequestTable;
